export default  {
      "openingScreen": {
        "message": "Learn how to use CrxMouse with",
        "description": "Start game screen. Sentence finishes with the words - The Mouse Chase"
    },
     "startGame": {
        "message": "Start Game",
        "description": "Start game option - on screen 1"
    },
     "settings": {
        "message": "CrxMouse Settings",
        "description": "Settings option. Don't translate the word - CrxMouse - on screen 1 and 6"
    },
     "gestureList": {
        "message": "Gesture List",
        "description": "Gesture list option - on screen 1 and 6"
    },
     "playLater": {
        "message": "Play Later",
        "description": "Play later option - on screen 1"
    },
    "playAgain": {
        "message": "Play Again",
        "description": "Play again option - on screen 6"
    },
    "startGameScreen0": {
        "message": "to start game",
        "description": "First sentence of the first screen for users that don't have CrxMouse installed - on screen 0"
    },
     "firstGestureInstructionDownload": {
        "message": "download CrxMouse on chrome",
        "description": "CrxMouse is available on Chrome extension store. This is the CTA that sends the user to CrxMouse on Chrome. Do not translate the word - CrxMouse - on screen 0"
    },
    "firstDownloadNow": {
        "message":"download now",
        "description": "CTA to download CrxMouse - on screen 0"
    },
    "gestureInstructions1": {
        "message": "scroll down using a mouse gesture",
        "description": "gesture instructions on screen 1 of the game"
    },
    "gameReference1": {
        "message": "*** start the chase ***",
        "description": "reference to the mouse chase game on screen 1 of the game"
    },
    "movementInstructions1": {
        "message": "hold down the <span class='yellow-text'>right-click</span> anywhere on the screen + drag a bit <span class='yellow-text'>down</span> + let go",
        "description": "movement instructions on screen 1 of the game"
    },
     "gestureInstructions2": {
        "message": "open a link in a new tab using a super drag gesture",
        "description": "gesture instructions on screen 2 of the game"
    },
    "gameReference2": {
        "message":"run from the monster!!!",
        "description": "reference to the mouse chase game on screen 2 of the game"
    },
     "movementInstructions2Part1": {
        "message": "hold down the <span class='yellow-text'>left-click</span> over",
        "description": "movement instructions on screen 1 of the game - part 1 of the sentence"
    },
     "movementInstructions2Part2": {
        "message": "<a class='blue-link' href='/the-mouse-chase-2' target='_blank'>this link</a>",
        "description": "movement instructions on screen 1 of the game - part 2 of the sentence"
    },
     "movementInstructions2Part3": {
        "message": " + drag a bit <span class='yellow-text'>right</span> + let go",
        "description": "movement instructions on screen 1 of the game - part 3 of the sentence"
    },
     "gestureInstructions3": {
        "message": "Navigate to the left tab using a mouse gesture",
        "description": "gesture instructions on screen 3 of the game"
    },
    "gameReference3": {
        "message":"go back! the princess is in danger",
        "description": "reference to the mouse chase game on screen 3 of the game"
    },
     "movementInstructions3": {
        "message":"hold down the <span class='yellow-text'>right-click</span> anywhere on the screen + drag your mouse a bit <span class='yellow-text'>up & left</span> + let go",
        "description": "movement instructions on screen 3 of the game"
    },
     "gestureInstructions4": {
        "message": "scroll to the top of this page using a mouse gesture",
        "description": "gesture instructions on screen 4 of the game"
    },
    "gameReference4": {
        "message":"defeat the cat to reach the princess",
        "description": "reference to the mouse chase game on screen 4 of the game"
    },
     "movementInstructions4": {
        "message":"hold down the <span class='yellow-text'>right-click</span> anywhere on the screen + drag a bit <span class='yellow-text'>right & up</span> + let go",
        "description": "movement instructions on screen 4 of the game"
    },
     "gestureInstructions5": {
        "message": "Save an image using a super drag gesture",
        "description": "gesture instructions on screen 5 of the game"
    },
    "gameReference5": {
        "message":"you've made it! now save the princess",
        "description": "reference to the mouse chase game on screen 5 of the game"
    },
     "movementInstructions5": {
        "message":"hold down the <span class='yellow-text'>left-click</span> over the princess image + drag a bit <span class='yellow-text'>down</span> + let go",
        "description": "movement instructions on screen 5 of the game"
    },
    "fifthFinishGame": {
        "message": "click here to finish the game",
        "description": "A CTA the user needs to click in order to finish the game."
    },
    "sixthCongratulations": {
        "message": "<span class='white-text'>congratulations!</span>",
        "description": "The last screen of the game when the user is congratualated for finishing the game."
    },
    "sixthCrxChampion": {
        "message": "<br>you're now a CrxMouse champion",
        "description": "When translating, try to find the corresponding phrase for the phrase - CrxMouse champion, without translating the word - CrxMouse."
    },
    "soundOn": {
        "message": "turn on sound",
        "description": "instructions next to the sound icon when it's off"
    },
    "soundOff": {
        "message": "turn off sound",
        "description": "instructions next to the sound icon when it's on"
    },
    "hearts": {
        "message": "earn hearts as you play",
        "description": "headline of hearts section"
    },
    "firstExistPopuptitle": {
        "message": "Don't go yet!",
        "description": "title of exit popup"
    },
     "firstExistPopupSubtitle": {
        "message": "This is your chance to learn how to use mouse gestures",
        "description": "subtitle of  of exit popup"
    },
     "firstExistPopupSubSubtitle": {
        "message": "(and save the princess from the evil cat...)",
        "description": "sub-subtitle of  of exit popup"
    },
    "firstExitPopupCTA1": {
        "message": "Start Game",
        "description": "First CTA of first exit popup"
    },
    "exitPopupsCTA2": {
        "message": "Watch Tutorial Instead",
        "description": "Second CTA of the exit popups"
    },
    "exitPopupsCTA3": {
        "message": "Go to CrxMouse Settings",
        "description": "Third CTA of the exit popups"
    },
    "secondExistPopupCTA1": {
        "message": "Continue Game",
        "description": "subtitle of the second exit popup"
    },
     "needHelpPopupTitle": {
        "message": "Need Help?",
        "description": "Title of the 'need help' popup"
    },
     "needHelpPopupSubtitle": {
        "message": "Watch a gameplay",
        "description": "Subtitle of the 'need help' popup that opens a video showing someone playing the game"
    },
     "needHelpPopupClose": {
        "message": "close",
        "description": "Subtitle of the 'need help' popup that opens a video showing someone playing the game"
    },
    "settingsIcon": {
        "message": "settings",
        "description": "text next to settings icon - appears in all screens"
    },
    "secondExistPopupSubtitle": {
        "message": "You only have $NUMBER$ more gestures to learn",
        "description": "subtitle of the second exit popup",
        "placeholders": {
            "number": {
                "content": "$1"
            }
        }
    }
}
